import Sterilizer from './Sterilizer';

export default Sterilizer;